import * as React from 'react';
import * as css from './ImageViewer.scss';

import { CircularProgressBar, Loader } from 'wix-style-react';

interface ImageViewerLoaderProps {
  progress: number;
  scenario?: string;
}

export class ImageViewerLoader extends React.Component<ImageViewerLoaderProps> {

  render() {
    const { progress, scenario } = this.props;
    return (
      <div className={`${css.loader} ${scenario === 'update' ? css.updateScenario : ''}`}>
        {!progress && <Loader size="small"/>}
        {!!progress && <div className={css.circular}><CircularProgressBar size="small" value={progress}/></div>}
      </div>);
  }
}
